import React from 'react';
import { motion } from 'framer-motion';
import { Gift, ShieldCheck, Clock, CheckCircle2, Sparkles, ArrowRight } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function OfferSection() {
  const includes = [{
    item: 'Diagnóstico de tu Triángulo Roto — identificamos tu herida raíz',
    value: 'Claridad que años de intentarlo solo no te dieron'
  }, {
    item: 'Herramienta personalizada para tu herida espiritual',
    value: 'Reconecta tu fe de forma práctica y sin culpa'
  }, {
    item: 'Estrategia concreta para tu relación con el dinero',
    value: 'No teoría — pasos que puedes aplicar esta semana'
  }, {
    item: 'Plan de acción para romper el ciclo de disciplina',
    value: 'Basado en quién eres tú, no en fórmulas genéricas'
  }, {
    item: 'Espacio 100% confidencial y sin juicio',
    value: 'Habla con total honestidad — aquí no hay agenda'
  }, {
    item: 'Grabación de la sesión (opcional)',
    value: 'Para que puedas volver a las herramientas cuando las necesites'
  }];
  return <section id="reserva" className="py-14 px-4 bg-navy-950 text-white relative overflow-hidden" data-id="element-135">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-136" />

      <div className="max-w-4xl mx-auto relative z-10 space-y-14" data-id="element-137">
        {/* Lo que obtienes */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} data-id="element-138">
          <div className="flex items-center justify-center gap-3 text-gold-400 mb-8" data-id="element-139">
            <Gift className="w-6 h-6" data-id="element-140" />
            <h2 className="text-sm font-bold tracking-widest uppercase" data-id="element-141">
              Lo que obtienes en esta charla personalizada
            </h2>
          </div>

          {/* Value comparison table */}
          <div className="bg-navy-900/50 border border-navy-800 rounded-3xl overflow-hidden backdrop-blur-sm" data-id="element-142">
            {/* Header */}
            <div className="grid grid-cols-1 md:grid-cols-2 bg-navy-900/80 border-b border-navy-800" data-id="element-143">
              <div className="px-6 py-4 flex items-center gap-2 text-white font-bold tracking-wide" data-id="element-144">
                <CheckCircle2 className="w-5 h-5 text-gold-400" data-id="element-145" />
                <span data-id="element-146">Lo Que Incluye</span>
              </div>
              <div className="px-6 py-4 flex items-center gap-2 text-white font-bold tracking-wide border-t md:border-t-0 md:border-l border-navy-800" data-id="element-147">
                <Sparkles className="w-5 h-5 text-gold-400" data-id="element-148" />
                <span data-id="element-149">El Valor Real</span>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-navy-800" data-id="element-150">
              {includes.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2" data-id="element-151">
                  <div className="px-6 py-5 text-white/95 leading-relaxed" data-id="element-152">
                    {row.item}
                  </div>
                  <div className="px-6 py-5 text-navy-200 leading-relaxed md:border-l border-navy-800 border-t md:border-t-0 italic" data-id="element-153">
                    {row.value}
                  </div>
                </div>)}
            </div>
          </div>

          {/* Pricing block */}
          <div className="mt-10 bg-gradient-to-b from-navy-900 to-navy-950 border border-gold-500/30 rounded-3xl p-8 md:p-10 text-center shadow-[0_0_60px_-20px_rgba(211,154,34,0.4)]" data-id="element-154">
            <p className="text-navy-200 text-lg mb-2" data-id="element-155">
              <span className="mr-2" data-id="element-156">💰</span>
              Valor real de todo esto:{' '}
              <span className="line-through text-navy-400 font-semibold" data-id="element-157">
                $397
              </span>
            </p>

            <div className="my-6" data-id="element-158">
              <p className="text-gold-400 text-sm font-bold tracking-widest uppercase mb-3" data-id="element-159">
                🎯 Tu inversión hoy
              </p>
              <p className="text-6xl md:text-7xl font-serif font-bold text-white" data-id="element-160">
                $97{' '}
                <span className="text-2xl md:text-3xl text-gold-400 align-top" data-id="element-161">
                  USD
                </span>
              </p>
            </div>

            <p className="text-navy-300 text-sm md:text-base italic" data-id="element-162">
              Precio de lanzamiento — solo para los primeros{' '}
              <span className="text-gold-300 font-bold not-italic" data-id="element-163">
                10 clientes
              </span>
            </p>
          </div>

          {/* Mid CTA */}
          <div className="mt-10 text-center" data-id="element-164">
            <a href="#cta-final" className="group inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-950 px-8 py-5 rounded-full text-lg md:text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.5)] w-full md:w-auto" data-id="element-165">
              QUIERO RESERVAR MI ESPACIO
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-166" />
            </a>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-167">
          {/* Garantía */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-white text-navy-900 p-8 rounded-3xl" data-id="element-168">
            <div className="flex items-center gap-3 text-navy-900 mb-6" data-id="element-169">
              <ShieldCheck className="w-8 h-8 text-gold-500" data-id="element-170" />
              <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-171">
                Garantía sin riesgo
              </h3>
            </div>
            <p className="text-navy-700 mb-4" data-id="element-172">
              Si al final de nuestra charla sientes que no obtuviste ninguna
              claridad, ninguna herramienta útil, ni una sola perspectiva
              nueva...
            </p>
            <p className="text-2xl font-serif font-bold text-navy-900 mb-4" data-id="element-173">
              No pagas nada.
            </p>
            <p className="text-navy-600 font-medium" data-id="element-174">
              Así de simple. Así de justo. Porque mi trabajo es darte valor real
              — no venderte una sesión.
            </p>
          </motion.div>

          {/* Urgencia */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-gold-500 text-navy-950 p-8 rounded-3xl" data-id="element-175">
            <div className="flex items-center gap-3 text-navy-950 mb-6" data-id="element-176">
              <Clock className="w-8 h-8" data-id="element-177" />
              <h3 className="text-xl font-bold uppercase tracking-wide" data-id="element-178">
                Urgencia y Escasez
              </h3>
            </div>
            <p className="font-medium mb-4" data-id="element-179">
              Atiendo un número muy limitado de personas por semana.
            </p>
            <p className="mb-4 opacity-90" data-id="element-180">
              No por estrategia de marketing. Sino porque cada charla merece mi
              presencia total — y eso tiene un límite real.
            </p>
            <p className="font-bold text-lg" data-id="element-181">
              Si estás leyendo esto, hay un lugar disponible ahora mismo.
            </p>
            <p className="opacity-90 mt-2" data-id="element-182">
              Pero los espacios se llenan. Y el momento en que más necesitas
              esto... es ahora.
            </p>
          </motion.div>
        </div>

        {/* CTA Final */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="text-center pt-12" data-id="element-183">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-400 mb-8 animate-bounce" data-id="element-184">
            <ArrowRight className="w-8 h-8 rotate-90" data-id="element-185" />
          </div>

          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-186">
            Una conversación. Tres heridas. <br data-id="element-187" />
            <span className="text-gold-400" data-id="element-188">Tu vida, al otro lado.</span>
          </h2>

          {/* Pricing reminder above CTA */}
          <div className="mb-8 inline-flex flex-col items-center gap-2 bg-navy-900/60 border border-gold-500/30 rounded-2xl px-6 py-5 backdrop-blur-sm" data-id="element-189">
            <p className="text-navy-300 text-sm md:text-base" data-id="element-190">
              <span className="mr-1" data-id="element-191">💰</span>
              Valor real:{' '}
              <span className="line-through text-navy-400 font-semibold" data-id="element-192">
                $397
              </span>
            </p>
            <p className="text-3xl md:text-4xl font-serif font-bold text-white" data-id="element-193">
              Hoy: <span className="text-gold-400" data-id="element-194">$97 USD</span>
            </p>
            <p className="text-xs md:text-sm text-navy-300 italic" data-id="element-195">
              Precio de lanzamiento — solo primeros{' '}
              <span className="text-gold-300 font-bold not-italic" data-id="element-196">
                10 clientes
              </span>
            </p>
          </div>

          <a id="cta-final" href="https://www.inerciacero.com/cart/43776212041831:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 bg-gold-500 hover:bg-gold-400 text-navy-950 px-8 py-5 rounded-full text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-[0_0_40px_-10px_rgba(211,154,34,0.5)] w-full md:w-auto mb-8 scroll-mt-[50vh]" data-id="element-197">
            QUIERO RESERVAR MI ESPACIO
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-198" />
          </a>

          <p className="text-xl text-navy-300" data-id="element-199">
            Sin juicio. Sin agenda. Con soluciones reales.
          </p>
        </motion.div>
      </div>
    </section>;
}